import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {PublicHolidaysModelService} from '../../../Models/Rrhh/Public-holidays/public-holidays-model.service';
import {PublicHolidayStoreForm} from '../../../../Models/Rrhh/Public-holidays/public-holiday-store.model';

@Injectable({
  providedIn: 'root'
})
export class PublicHolidaysApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: PublicHolidaysModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener todos los festivos trabajados
   *
   */
  public getPublicHolidaysWorked(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('public_holidays_return', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener todos los festivos disponibles
   *
   */
  public getAvailablePublicHolidays(): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('available_public_holidays_return', {}, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Devolver festivo
   *
   */
  public setPublicHolidays(params: PublicHolidayStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('return_worked_holidays', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      })

    })

  }

}
